<template>
    <div class="error-box" role="alert">
        <div
            v-for="(fieldErrors, field, index) in errors"
            :key="index"
        >
            <div
                v-for="(error, i) in fieldErrors"
                :key="i"
                class="message message--error-big"
            >
                {{ $t(error) | capitalize }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NonFieldErrors',
        props: {
            errors: {
                Errors: Object,
                required: true
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/NonFieldErrors.vue